import React from 'react';

const ClockIcon = ({ color = 'currentColor', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" style={{ marginRight: 6 }}>
    <circle cx="11" cy="11" r="9" stroke={color} strokeWidth="2" strokeLinecap="square" />
    <path d="M11 5.5V11L14 14" stroke={color} strokeWidth="2" strokeLinecap="square" />
  </svg>
);

export default ClockIcon;
